import { SkuCardImageProps } from '@/types/props/components/skus';
import imageLoader from '@/utilites/imageLoader';
import { Card } from 'react-bootstrap';
import LoadingComponent from '../../../LoadingComponent';
import ImageFallback from '@/components/common/ImageFallback';
import { SkuMainImage } from '../../../../../utilites/get-sku-main-image';

export default function SkuCardImageDesktop({ sku }: SkuCardImageProps) {
  if (sku === null) {
    return (
      <LoadingComponent
        as="div"
        loading={true}
        componentProps={{
          className: 'tw-p-4 tw-w-[300px] tw-h-[271px]',
        }}
      >
        <span
          className="max-h-271 tw-w-full tw-h-full tw-block"
          aria-label="loading image..."
        ></span>
      </LoadingComponent>
    );
  }
  return (
    <Card.Img
      as={() => (
        <SkuMainImage
          className={`mb-4 max-h-271 object-fit-contain pt-4`}
          width={300}
          height={271}
          loader={imageLoader}
          style={{ width: '100%', height: '100%', objectFit: 'contain' }}
          alt={sku?.name ?? ''}
          src={sku ? (sku.mainImageUrl as string) : ''}
        />
      )}
    />
  );
}
